<template>
<div>
  <CDropdown
    inNav
    class="c-header-nav-items"
    placement="bottom-end"
    add-menu-classes="pt-0"
  >
    <template #toggler>
      <CHeaderNavLink>        
        <div class="c-avatar">          
          <img
            src="img/avatars/user.png"
            class="c-avatar-img"
          />               
          <div> <span class="avatar-status bg-success"></span></div>
        </div>
      </CHeaderNavLink>
    </template>
    <CDropdownHeader tag="div" class="text-center" color="light">
      <strong>個人帳戶</strong>
    </CDropdownHeader>
    <CDropdownItem @click="upatepwd">
      <CIcon name="cil-bell"/> 更新密碼     
      <CBadge color="primary" class="mfs-auto">99+</CBadge>
    </CDropdownItem>
    <!-- <CDropdownItem  @click="owner">
      <CIcon name="cil-settings" /> 個人資料
      <CBadge color="secondary" class="mfs-auto">20</CBadge>
    </CDropdownItem>
    <CDropdownItem @click="activite">
      <CIcon name="cil-task"/> 行為分析     
    </CDropdownItem>     -->
    <CDropdownDivider/>
    <CDropdownItem @click="logout">
      <CIcon name="cil-lock-locked" /> 登出
    </CDropdownItem>   
  </CDropdown>   
   <ejs-toast ref='toastRef' id='toast_type' :position='position'></ejs-toast>      
      <div class="control-section">
          <ejs-dialog ref="modalPwdDialog" :showCloseIcon='true' :isModal='true' :closeOnEscape='true' :visible='false' header='變更個人密碼' :buttons='dialog_buttons' 
              width='400px'>
              <div formGroup="orderForm">                   
                  <div class="form-row">
                      <div class="form-group col-md-12">
                          <ejs-textbox id='txtpwd' floatLabelType="Auto" placeholder="請輸入密碼" type="password" v-model="e_pwd" aria-required="true"></ejs-textbox>   
                      </div> 
                      <div class="form-group col-md-12">
                          <ejs-textbox id='txtpwd2' floatLabelType="Auto" placeholder="再次確認密碼" type="password" v-model="e_pwd2" aria-required="true"></ejs-textbox>    
                      </div>
                  </div> 
              </div>                
          </ejs-dialog> 
        </div>
    </div>
</template>

<script>
import Vue from "vue";
import { DialogPlugin } from '@syncfusion/ej2-vue-popups';  
import { TextBoxPlugin } from '@syncfusion/ej2-vue-inputs';
import { ToastComponent } from "@syncfusion/ej2-vue-notifications";

Vue.use(DialogPlugin);
Vue.use(TextBoxPlugin);

export default {
  name: 'TheHeaderDropdownAccnt',
  components: {   
    'ejs-toast': ToastComponent,
  },
  data () {
    return { 
      e_pwd: '', e_pwd2: '',
      position: { X: 'Right', Y: "Bottom" }, ShowBtn: false,
      dialog_buttons: [{
          click: this.dialog_editOkClick,
          buttonModel: { content: '確認更改密碼', isPrimary: true } 
        }, { 
          click: function() { this.hide(); }, 
          buttonModel: { content: '取消', isPrimary: false}
      }],
    }
  },
  methods: {    
      logout() {
        localStorage.removeItem('token');
        localStorage.removeItem('name');
        this.$router.push('/pages/login')      
      },
      activite() {
        this.$router.push('/system/activite')  
      },
      owner() {
        this.$router.push('/system/owner')      
      },
      upatepwd() {
        this.$refs.modalPwdDialog.show();
      },
      dialog_editOkClick: function () {  
        if (this.e_pwd != this.e_pwd2) {  
          this.e_msg = "兩者密碼不相同,請重新輸入"
          return
        }
        this.axios({
            method: 'put',
            baseURL: Vue.prototype.GLOBAL.baseURL,
            url: 'Account/ChangePwd',
            headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
            data : {
              pwd: this.e_pwd
            }
          })
          .then((response) => {             
            if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); this.hideLoading(); return; } 
            this.$refs.modalPwdDialog.hide();          
            this.showMsg(`密碼已修正,請於下次登入時使用新密碼`);  
            this.e_pwd = "";
            this.e_pwd2 = "";
          })
          .catch((error) => {this.showError(error, true)}
        )        
      },
      showError: function (error) {     
        this.hideLoading();
        if (error.response.status == 400) {
          for(var key in error.response.data.errors){      
            this.$refs.toastRef.show( { title: '警告!', content: error.response.data.errors[key][0] , cssClass: 'e-toast-warning', icon: 'e-warning toast-icons' });           
          }
          return;
        }   
        if (error.response.status == 401) {
          localStorage.removeItem('token'); this.$router.push('/login');
          return;
        }
        this.$refs.toastRef.show( { title: '錯誤!', content: error.response.status, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' });
      },
      showMsg: function (msg) {
        this.$refs.toastRef.show( { title: '訊息!', content: msg, cssClass: 'e-toast-info', icon: 'e-info toast-icons' });
      },
    },
    created() {
    },
}

</script>
<style scoped>
  .c-icon {
    margin-right: 0.3rem;
  }
  .avatar-status {
    position: absolute;
    bottom: 0;
    display: block;
    border: 1px solid #fff;
    border-radius: 50em;
    width: 15px;
    height: 15px;
    right: 0px;
  } 
</style>
<style lang="scss" src="../scss/base.scss"></style>